import { Form, Input, InputNumber, Radio, Select, TimePicker } from "antd";
import type { FormInstance, Rule } from "antd/es/form";
import { WeekDays } from "../../../shared/constants";

const { RangePicker } = TimePicker;

const ServiceCenterForm = ({
    mode,
    form
}: {
    mode: string;
    form: FormInstance;
}) => {
    const requiredRule: Rule = { required: true, message: "Required" };

    return (
        <div className="mb-5">
            <Form.Item name="name" label={<>Name<span style={{ color: "red", marginLeft: "2px" }}>*</span></>} rules={[requiredRule]}>
                <Input size="large" placeholder={"Name"} />
            </Form.Item>
            <Form.Item name="hotlineNo" label={<>Hotline No.<span style={{ color: "red", marginLeft: "2px" }}>*</span></>} rules={[requiredRule]}>
                <Input inputMode="tel" size="large" placeholder={"Hotline No."} />
            </Form.Item>
            <Form.Item name="email" label={<>Email</>} rules={[{ type: "email", message: "Valid email required" }]}>
                <Input inputMode="email" size="large" placeholder={"Email Address"} />
            </Form.Item>
            <Form.Item name="weeklyOffDays" label={"Weekly Off-days"}>
                <Select
                    mode="multiple"
                    placeholder="Select days"
                    options={WeekDays.map(x => ({ label: x, value: x }))}
                />
            </Form.Item>
            <Form.Item name="workingHour" label={"Working Hour"}>
                <RangePicker className="w-full"
                    format="hh:mm A"
                    minuteStep={15}
                />
            </Form.Item>
            <Form.Item name="daysOfAdvanceSerial" label={"Advance Serial"}>
                <InputNumber inputMode="numeric" min={0} max={100} className="w-full" suffix={"Day(s)"} />
            </Form.Item>
            <Form.Item name="serialNoPolicy" label={"Serial Number Policy"}>
                <Radio.Group
                    optionType="button"
                    options={[
                        { label: "Combined", value: "C" },
                        { label: "Service type wise", value: "T" }
                    ]}
                    buttonStyle="solid"
                    block
                ></Radio.Group>
            </Form.Item>
            <Form.Item name="noOfReservedSerials" label={"Reserved Serials"}>
                <InputNumber inputMode="numeric" min={0} className="w-full" prefix={"First"} suffix="Serial(s)" />
            </Form.Item>
            <Form.Item name="dailyQuota" label={"Daily Quota"}>
                <InputNumber inputMode="numeric" min={0} className="w-full" suffix={"Serials"} />
            </Form.Item>
        </div>
    );
};

export default ServiceCenterForm;
